import { render, staticRenderFns } from "./users-list.vue?vue&type=template&id=b1b599c6&scoped=true"
import script from "./users-list.vue?vue&type=script&lang=js"
export * from "./users-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b599c6",
  null
  
)

export default component.exports